import React from 'react'
import HistoryIcon from '@material-ui/icons/History';
import Button from 'components/Button';
import Tr from 'translations/Translations';


function HistoryButton({
	classes,
	onClick,
	variant = 'outlined',
	Icon = HistoryIcon,
	children = Tr('history'),
	...other
}) {
	return (
		<Button
			variant={variant}
			Icon={Icon}
			onClick={onClick}
			{...other}
		>
			{children}
		</Button>
	)
}

export default HistoryButton;